import { styled, CardContent } from '@mui/material';

export const FeedbackReviewsDownloaderCardContent = styled(CardContent)(
  ({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  }),
);
